import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js'
import { createBrowserHistory } from 'history'
import { getConfig } from '../configs/config'

const browserHistory = createBrowserHistory({ basename: '' })
const userData = localStorage.getItem('userData')
  ? JSON.parse(localStorage.getItem('userData'))
  : null
const reactPlugin = new ReactPlugin()
const config = getConfig()
const ai = new ApplicationInsights({
  config: {
    connectionString:
      config?.APP_INSIGHTS_CONNECTION_STR,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    }
  }
})
const customProps = {
  AppName: 'Smart Insights',
  UserEmail: userData?.username || null
}
ai.loadAppInsights()
ai.trackPageView({
  properties: customProps
})

export default (Component) => withAITracking(reactPlugin, Component)
export const appInsights = reactPlugin
export { ai, reactPlugin }
export { customProps }
